export default __webpack_public_path__ + "static/media/usa.5923db83.png";